import { render, staticRenderFns } from "./BannerUpdateForm.vue?vue&type=template&id=9af1b5ae&"
import script from "./BannerUpdateForm.vue?vue&type=script&lang=js&"
export * from "./BannerUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9af1b5ae')) {
      api.createRecord('9af1b5ae', component.options)
    } else {
      api.reload('9af1b5ae', component.options)
    }
    module.hot.accept("./BannerUpdateForm.vue?vue&type=template&id=9af1b5ae&", function () {
      api.rerender('9af1b5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BannerUpdateForm.vue"
export default component.exports